
export class AlertFeedback {

    alertFeedbackId?: number;
    alertFeedbackDate?: number;
    alertInstanceId?: number;
    alertStatus?: string;
    alertRuleId?: string;
    alertOpenedDate?: number;
    alertClosedDate?: number;
    alertAckDate?: number;
    alertType?: string;
    alertClient?: string;
    alertPlant?: string;
    alertLine?: string;
    alertAssetName?: string;
    feedback?: string;
    userEmail?: string;
    userType?: string;
}
